import React from 'react'
import { CSpinner } from '@coreui/react'
import PropTypes from 'prop-types'

const LoadingSpinner = ({ fullScreen = false, text = 'Loading...', size = 'md' }) => {
  // CSpinner only accepts 'sm' or no size prop (default is medium)
  const spinnerSize = size === 'sm' ? 'sm' : undefined
  
  if (fullScreen) {
    return (
      <div 
        className="d-flex flex-column justify-content-center align-items-center" 
        style={{ minHeight: '100vh' }}
      >
        <CSpinner color="primary" size={spinnerSize} />
        {text && <p className="mt-3 text-muted">{text}</p>}
      </div>
    )
  }

  return (
    <div className="d-flex flex-column justify-content-center align-items-center p-5">
      <CSpinner color="primary" size={spinnerSize} />
      {text && <p className="mt-3 text-muted">{text}</p>}
    </div>
  )
}

LoadingSpinner.propTypes = {
  fullScreen: PropTypes.bool,
  text: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md'])
}

export default LoadingSpinner